const moment = require('moment/moment');
const UserFacingError = require('@/libraries/DigiTickets/Errors/UserFacingError');

/**
 * Accepts a date of birth as a string (in the specified format)
 * and returns that person's current age.
 *
 * @param {string} dobString
 * @param {string} format
 *
 * @throws {UserFacingError}
 * @returns {number}
 */
const calculateAgeFromDob = (dobString, format = 'DD/MM/YYYY') => {
    let date = moment(dobString, format);

    if (!date.isValid()) {
        throw new UserFacingError('Please enter a valid date.', 'FIELDS.ERROR--INVALID-DATE');
    }

    let age = null;
    if (moment().diff(date, 'seconds') > 0) {
        // Date is valid and not in the future.
        age = moment().diff(date, 'years');
    }

    if (age == null || age >= 150) {
        // Throw a slightly different error message if a valid date, but invalid for a DOB, was entered.
        throw new UserFacingError('Please enter a valid date of birth.', 'FIELDS.ERROR--INVALID-DOB');
    }

    return age;
};

module.exports = {
    calculateAgeFromDob,
};
